import { httpsCallable } from "firebase/functions";
import { query, getDocs, orderBy, collection } from "firebase/firestore";

import { Utils } from "utils";
import { functions, db } from "configs";
import { COLLECTIONS, FUNCTIONS } from "constants/firebase";
import { Duration, IRoute, IRouteListItem, Iterable } from "types";

export const build = async (props: any) => {
  try {
    const cloudFuncName =
      process.env.NODE_ENV === "production"
        ? FUNCTIONS.BUILD_ROUTE
        : FUNCTIONS.BUILD_ROUTE_DEV;

    const callable = httpsCallable(functions, cloudFuncName, {
      timeout: 540000,
    });

    const response = await callable(props);
    return Promise.resolve(response.data as IRoute);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const list = async () => {
  const c = collection(db, COLLECTIONS.ROUTES);
  const q = query(c, orderBy("createdAt", "desc"));
  const response = await getDocs(q);
  const documents = Utils.Helpers.castDocs<Iterable<IRouteListItem>>(response);
  return Promise.resolve(documents);
};

export const get = async (props: { id: string }) => {
  try {
    const callable = httpsCallable<
      { requestIds: string[] },
      { list: Iterable<IRouteListItem>[] }
    >(functions, FUNCTIONS.GET_ROUTES_LIST);

    const response = await callable({ requestIds: [props.id] });

    return Promise.resolve(
      response.data.list.at(0) ? response.data.list[0] : undefined
    );
  } catch (error) {
    return Promise.reject(error);
  }
};

export const usersRoutes = async (props: {
  roadType?: string;
  duration?: Duration;
  countryCode?: string;
  afterCreatedAt?: number;
}) => {
  try {
    const callable = httpsCallable<
      typeof props,
      { list: Iterable<IRouteListItem>[]; totalCount: number }
    >(functions, FUNCTIONS.GET_USERS_ROUTES, { timeout: 540000 });

    const response = await callable(props);
    return Promise.resolve(response.data);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const rate = async (props: {
  email: string;
  rating: number;
  requestID: string;
}) => {
  try {
    const callable = httpsCallable<typeof props, unknown>(
      functions,
      FUNCTIONS.RATE_ROUTE
    );
    await callable(props);

    return Promise.resolve();
  } catch (error) {
    return Promise.reject(error);
  }
};
